import"@babel/runtime-corejs3/core-js-stable/promise";import{sign as o}from"jsonwebtoken";import{mockAuth0User as r}from"../lib/mockGuildUser.js";var e=r({given_name:"Tom"}),m=function(){return o(e,"shhh")};export{m as mockJwt};
//# sourceMappingURL=mockClient.js.map
